export default "__VITE_ASSET__d8e6edcf__"